import { render, staticRenderFns } from "./kebenDec.vue?vue&type=template&id=16961db2&scoped=true"
import script from "./kebenDec.vue?vue&type=script&lang=js"
export * from "./kebenDec.vue?vue&type=script&lang=js"
import style0 from "./kebenDec.vue?vue&type=style&index=0&id=16961db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16961db2",
  null
  
)

export default component.exports